module.exports = __webpack_public_path__ + "img/spinneys-original-960.5f8c4071.png";